<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-5">
                    <h4 class="card-title mb-0">{{ title }} <small class="text-muted">{{ subtitle }}</small></h4>
                </div><!--col-->

                <div class="col-sm-7">
                    <slot name="buttons"></slot>
                </div>
            </div><!--row-->

            <div class="row mt-4">
                <div class="col">
                    <slot name="table"></slot>
                </div><!--col-->
            </div>
        </div><!--card-body-->
    </div><!--card-->
</template>

<script>

export default {
    name: "Main",
    props: {
        title: String,
        subtitle: String
    },
}
</script>

<style scoped>

.btn {
    cursor: pointer;
}

</style>